<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » 名称ダイアログの説明
  </div>
<div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card appearance="outlined" class="manual-card">
      <mat-card-header>
        <mat-card-title><span>名称ダイアログの説明</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/name-dialog.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> 閉じるボタン
        </div>
        <div class="manual-explain">
          クリックすることでダイアログを閉じます。<br>
          その際、選択した内容は反映されません。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> 全言語自動翻訳
        </div>
        <div class="manual-explain">
          全言語の自動翻訳チェックボックスに対して、ON/OFFを切り替えます。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> 名称（メイン言語）
        </div>
        <div class="manual-explain">
          名称を設定します。<br>
          <a [href]="projectDialogLink">プロジェクト情報：編集画面</a>で設定された言語の１番目のものがメイン言語となります。<br>
          <span class="manual-explain-notes">※必須項目</span>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> 名称（翻訳用）
        </div>
        <div class="manual-explain">
          自動翻訳用の名称を設定します。<br>
          ここで設定された内容をもとに各言語の翻訳を行います。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/E.png"> 名称（他言語）
        </div>
        <div class="manual-explain">
          名称を設定します。<br>
          自動翻訳にチェックを入れることで翻訳処理が実行されます。（設定内容は翻訳処理によって上書きされます）
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/F.png"> 更新ボタン
        </div>
        <div class="manual-explain">
          クリックすることで編集した内容を反映します。
        </div>

      </mat-card-content>
    </mat-card>
  </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">Manual Top</a> » Name Dialog Description
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

      <mat-card class="manual-card">
        <mat-card-header>
          <mat-card-title><span>Name Dialog Description</span></mat-card-title>
        </mat-card-header>

        <mat-card-content>
          <div class="manual-img">
            <img src="assets/img/manual/en_name-dialog.png" width="100%">
          </div>

          <div class="manual-explain-title">
            <img src="assets/img/manual/A.png"> Close Button
          </div>
          <div class="manual-explain">
            Clicking this button will close the dialog.<br>
            The selected content will not be applied upon closing.
          </div>

          <div class="manual-explain-title">
            <img src="assets/img/manual/B.png"> Auto-Translate All Languages
          </div>
          <div class="manual-explain">
            Toggles the ON/OFF state of the auto-translate checkbox for all languages.
          </div>

          <div class="manual-explain-title">
            <img src="assets/img/manual/C.png"> Name (Main Language)
          </div>
          <div class="manual-explain">
            Set the name.<br>
            The first language set in the <a [href]="projectDialogLink">Project Information: Edit Screen</a> becomes the main language.<br>
            <span class="manual-explain-notes">*Required field</span>
          </div>

          <div class="manual-explain-title">
            <img src="assets/img/manual/D.png"> Name (For Translation)
          </div>
          <div class="manual-explain">
            Set the name for automatic translation.<br>
            The content set here is used as the basis for translations into other languages.
          </div>

          <div class="manual-explain-title">
            <img src="assets/img/manual/E.png"> Name (Other Languages)
          </div>
          <div class="manual-explain">
            Set the name.<br>
            Checking the auto-translate box will execute the translation process (the content will be overwritten by the translation process).
          </div>

          <div class="manual-explain-title">
            <img src="assets/img/manual/F.png"> Update Button
          </div>
          <div class="manual-explain">
            Clicking this button applies the edited content.
          </div>

        </mat-card-content>
      </mat-card>

  </div>

</div>